import React from 'react';
import cs from 'classnames';
import {reduxForm} from 'redux-form';
import {connect} from 'react-redux';
import get from 'lodash/get';

import {updateUser} from '~/modules/user/actions';
import Button from '~/components/common/Button';
import LabeledInput from '~/components/common/LabeledInput';
import mapDispatch from '~/misc/mapDispatch';
import saferwatch from '~/api/saferwatch';
import {track, trackName} from '~/misc/metrics';

import sharedCSS from '~/components/shared.css';
import css from './index.css';

const checkDOT = (getState, inputDot, raiseInvalidDot) => saferwatch(getState, `/DOT/${inputDot}`).catch((error) => {
  if (error.response && error.response.status === 404) {
    throw raiseInvalidDot();
  }
  throw error;
}).then((response) => {
  if (get(response, 'operation.types.carrier') !== 'Yes') {
    throw raiseInvalidDot();
  }
  return response;
});


const userDataToChange = (inputDot, sw) => {
  const swIdentity = get(sw, '[CarrierService.CarrierLookup].CarrierDetails.Identity');
  const companyName = swIdentity.dbaName || swIdentity.legalName;

  if (!companyName) {
    return {dot: inputDot};
  }

  return {dot: inputDot, company: {name: companyName}};
};


const submitStep1 = ({dot, phone}) => (dispatch, getState) => {
  let allErrors = {};
  if (!dot) {
    allErrors.dot = 'Please, fill the DOT';
  }

  if (!phone) {
    allErrors.phone = 'Please, fill the phone';
  }

  if (Object.keys(allErrors).length) {
    return Promise.reject(allErrors);
  }

  const {user: {id}} = getState();

  return checkDOT(getState, dot, () => ({dot: 'This DOT cannot be used'})).then(sw => {
    const data = userDataToChange(dot, sw);

    return dispatch(updateUser(id, {...data, phone: {number: phone}}))
      .catch(() => Promise.reject({_error: true}))
      .then(() => {
        track('userbanner_dot_phone_filled', {dot, phone});
      });
  });
};

const submitStep2 = ({firstName, lastName}) => (dispatch, getState) => {
  let allErrors = {};
  if (!firstName) {
    allErrors.firstName = 'Please, fill the first name';
  }

  if (!lastName) {
    allErrors.lastName = 'Please, fill the last name';
  }

  if (Object.keys(allErrors).length) {
    return Promise.reject(allErrors);
  }

  const {user: {id}} = getState();


  return dispatch(updateUser(id, {first_name: firstName, last_name: lastName}))
    .catch(() => Promise.reject({_error: true}))
    .then(() => {
      track('userbanner_name_filled');
      trackName(firstName, lastName);
    });
};


const submitForm = (fields) => fields.step1 ? submitStep1(fields) : submitStep2(fields);

const UserBannerForm = reduxForm({
  form: 'userProps',
  fields: ['firstName', 'lastName', 'phone', 'dot'],
})((props) => (
  <div
    className={cs(sharedCSS.wideStretchable, sharedCSS.box, css.wrap, 'qa-user-banner')}
  >
    <form data-qa='user-data-from'>
      <div className={css.row}>
        <div className={css.message}>
          {`(${props.step1 ? '1' : 2}/2)`} Please, fill your {props.step1 ? 'profile information' : 'name'}
          {props.error && <div className={css.error}>Unknown error occurred</div>}
        </div>
        <div className={css.fromPart}>
          {props.step1
            ? (<div className={css.inputsBlock}>
              <LabeledInput
                wrapClassName={css.block}
                autoFocus='true'
                mods={['wide', 'large']}
                label='DOT'
                {...props.fields.dot}
              />
              <LabeledInput
                wrapClassName={css.block}
                autoFocus='true'
                mods={['wide', 'large']}
                label='Phone'
                {...props.fields.phone}
              />
            </div>)
            : (<div className={css.inputsBlock}>
              <LabeledInput
                wrapClassName={css.block}
                autoFocus='true'
                mods={['wide', 'large']}
                label='First name'
                {...props.fields.firstName}
              />
              <LabeledInput
                wrapClassName={css.block}
                autoFocus='true'
                mods={['wide', 'large']}
                label='Last name'
                {...props.fields.lastName}
              />
            </div>)}

          <div className={css.submit} >
            <Button
              submit={true}
              mods={['wide', 'inputSize']}
              onClick={!props.submitting && props.handleSubmit}
            >
              {props.submitting ? '...' : 'Save'}
            </Button>
          </div>
        </div>
      </div>
    </form>
  </div>
));


const UserBanner = ({userIsNotLoggedIn, firstName, lastName, phone, dot, onSubmit, completed, step1}) =>
  // ((userIsNotLoggedIn || completed)
  ((userIsNotLoggedIn || completed || !completed)
    ? null
    : <UserBannerForm
      initialValues={({firstName, lastName, phone, dot})}
      onSubmit={(data) => onSubmit({
        ...data,
        step1,
      })}
      step1={step1}
    />);

export default connect(
  ({user}) => ({
    userIsNotLoggedIn: !user.isLoggedIn,
    firstName: user.firstName || '',
    lastName: user.lastName || '',
    phone: user.phone || '',
    dot: user.dot || '',
    step1: (!user.phone || !user.dot),
    completed: (user.firstName && user.lastName && user.dot && user.phone),
  }),
  mapDispatch({
    onSubmit: (props, fields) => submitForm(fields),
  })
)(UserBanner);



// WEBPACK FOOTER //
// ./src/components/search/UserBanner/index.js